export class Configuration {
    ServerUrl: string;
    ApiService: string;
    AppId: number;
    UserId: number;
    CookiesLifetime: number;
    CookiesRecipesListTime: number;
    DefaultSessionId: string;
    DefaultUserId: number;
    AuthRedirectUrl: string;
    HashSalt: string;
    ImagesPath: string;
    timeoutRequestDelayed: number;
    timeoutRequestMessage: string;
    TerminalKey: string;
    IntroUrl: string;
    AuthorizationShowTimeFirst: number;
    AuthorizationShowTime: number;
    AuthorizationShowTextTimeout: string;
    AuthorizationShowTextClicked: string;
    AppKeys: AppKeys = new AppKeys();
    SiteName: string;
    messageNotifyToSubscribe: string;
    NotifyCookiesLifetime: number;
    FirstNotifyCookiesLifetime: number;
    toolTipContent: string;
    toolTipTargetContent: string;
    toolTipSideBarContent: string;
    printIngredientsPdfTitle: string;
    printRecipePdfTitle: string;
    printRecipesListPdfTitle: string;
    printMenuPdfTitle: string;
    msgsErrorTime: number;
    msgsSuccessTime: number;
    studyCookiesLifeTime: number;
    welcomeButton1Text: string;
    welcomeButton2Text: string;
    welcomeButton3Text: string;
    welcomeButton4Text: string;
    proCaloriesPercent: number;
    fatCaloriesPercent: number;
    carCaloriesPercent: number;
    introTexts: string[];
    textPopUpInfoAboutRegistration: string;
    textMessageAfterAddRecipeAboutError: string;
    textMessageAfterAddRecipeAboutWarn: string;
    textForStudyPopupCall: string;
    durationWarningOfAddRecipe: number;
    cackleId: number;
    cackleRatingOff: boolean;
    cackleSort: string;
    cackleSize: number;
    cackleReplies: number;
    cackleLevel: number;
    cackleOn: boolean;
    cackleProviders: string;
    headerButtonKBJU: string;
    linkForOrderReadyMenu: string;
}

export class AppKeys {
    vkAppKey: number;
    fbAppKey: string;
    okAppKey: number;
    googleSecretKey: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/configuration.ts